import { render, staticRenderFns } from "./WaterMark.vue?vue&type=template&id=646a62ef"
import script from "./WaterMark.vue?vue&type=script&lang=js"
export * from "./WaterMark.vue?vue&type=script&lang=js"
import style0 from "./WaterMark.vue?vue&type=style&index=0&id=646a62ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports